import { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@upmc/ims.component-library';
import Icon from '../../../MDC/Icon/Icon';
import PropTypes from 'prop-types';

/**
 * Generic functional component for rendering a "Home" button.
 * @param {Object} props JSX attributes passed to component.
 * @returns {ReactElement} rendered component.
 */
const HomeButton = ({
	onClick,
	icon = false,
	children = 'Home',
	variant = 'outlined',
	...props
}) => {
	const history = useHistory();

	return (
		<Button
			{...props}
			onClick={e => {
				if (onClick) {
					onClick(e);
				}
				history.push('/index.html');
			}}
			variant={variant}
			endIcon={icon ? <Icon icon='home' /> : null}
		>
			{children}
		</Button>
	);
};

HomeButton.propTypes = {
	icon: PropTypes.bool,
	onClick: PropTypes.func,
	text: PropTypes.string,
};

export { HomeButton };
